import { render, staticRenderFns } from "./WeChatAdminSection.vue?vue&type=template&id=f51fa548&"
import script from "./WeChatAdminSection.vue?vue&type=script&lang=js&"
export * from "./WeChatAdminSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports